import util from '../../../util'

const loadImports = ({commit}, payload) => {

  return new Promise((resolve, reject) => {
    const headers = util.getAuthHeader()
    payload.context.axios.get(`storage/imports/${payload.idClient}`, {headers}).then((response) => {
      resolve(response.data)
    }).catch(error => {
      if (error.response) {
        util.showDialogError(payload.context, 'Ocurrió un error al cargar las importaciones.')
        reject(error.response)
      } else reject(error)
    });
  })
}

const saveImport = ({commit}, payload) => {

  return new Promise((resolve, reject) => {
    const headers = util.getAuthHeaderMultipart()

    var data = new FormData();
    data.append('file', payload.file);
    data.append('comment', payload.comment);
    data.append('type', payload.type);

    payload.context.axios.post(`storage/imports/${payload.idClient}`, data, {headers}).then((response) => {
      console.log(response.data)
      resolve(response.data)
    }).catch(error => {
      if (error.response) {
        util.showDialogError(payload.context, 'Ocurrió un error al importar el archivo.')
        reject(error.response)
      } else reject(error)
    });
  })
}

const getColumnsImport = ({commit}, payload) => {

  return new Promise((resolve, reject) => {
    const headers = util.getAuthHeader()
    payload.context.axios.get(`storage/imports/${payload.idImport}/columns`, {headers}).then((response) => {
      resolve(response.data)
    }).catch(error => {
      if (error.response) {
        util.showDialogError(payload.context, 'Ocurrió un error al cargar el archivo importado.')
        reject(error.response)
      } else reject(error)
    });
  })
}

const processImport = ({commit}, payload) => {

  return new Promise((resolve, reject) => {
    const headers = util.getAuthHeader()
    payload.context.axios.post(`storage/imports/process/${payload.idClient}/${payload.idImport}/${payload.idCategory}`, payload.fieldsImport, {headers}).then((response) => {
      resolve(response.data)
    }).catch(error => {
      if (error.response) {
        util.showDialogError(payload.context, error.response.data.message)
        reject(error.response)
      } else reject(error)
    });
  })
}

const getImportedFiles = ({commit}, payload) => {

  return new Promise((resolve, reject) => {
    const headers = util.getAuthHeader()
    payload.context.axios.get(`storage/imports/${payload.idImport}/files?${payload.params}`, {headers}).then((response) => {
      resolve(response.data)
    }).catch(error => {
      if (error.response) {
        util.showDialogError(payload.context, 'Ocurrió un error al cargar los archivos importados.')
        reject(error.response)
      } else reject(error)
    });
  })
}

export default {
  loadImports,
  saveImport,
  getColumnsImport,
  processImport,
  getImportedFiles
};



// WEBPACK FOOTER //
// ./src/store/modules/imports/actions.js